/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Onboarding_Progress_IndicatorInputs */

const en_onboarding_progress_indicator = /** @type {(inputs: Onboarding_Progress_IndicatorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Progress indicator`)
};

const es_onboarding_progress_indicator = /** @type {(inputs: Onboarding_Progress_IndicatorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Indicador de progreso`)
};

/**
* | output |
* | --- |
* | "Progress indicator" |
*
* @param {Onboarding_Progress_IndicatorInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const onboarding_progress_indicator = /** @type {((inputs?: Onboarding_Progress_IndicatorInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Onboarding_Progress_IndicatorInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_onboarding_progress_indicator(inputs)
	return en_onboarding_progress_indicator(inputs)
});